import { useState, useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import { Col, Row } from "react-bootstrap";
import { getPopularSoftSolList } from "api/CategoryService";
import { Link } from "react-router-dom";

const AccordionComponentHome = () => {
  const [popularSoftSolList, setPopularSoftSolList] = useState([]);

  useEffect(() => {
    const fetchPopularSoftSolList = async () => {
      const response = await getPopularSoftSolList();
      setPopularSoftSolList(response.body);
    };
    fetchPopularSoftSolList();
  }, []);

  // Split features into 3 columns
  const columns = [[], [], []];
  popularSoftSolList.forEach((item, index) => {
    columns[index % 3].push(item);
  });

  return (
    <Row>
      {columns.map((colItems, colIndex) => (
        <Col lg={6} xl={4} md={6} key={colIndex}>
          <Accordion defaultActiveKey="0">
            {colItems.map((category, idx) => (
              <Accordion.Item
                eventKey={String(idx)}
                key={`${colIndex}-${idx}`}
                className="mb-3"
              >
                <Accordion.Header className="bg-light">
                  <span className="fw-bold">{category.title}</span>
                </Accordion.Header>
                <Accordion.Body className="p-3">
                  {category.products.map((product) => (
                    <div key={product.id} className="mb-3 product-item">
                      <Link
                        to={`/product-details/${product.slug}`}
                        className="d-flex align-items-center text-decoration-none"
                      >
                        <div className="product-icon me-3">
                          <img
                            src={product.logoUrl}
                            alt={product.name}
                            className="rounded"
                            width="40"
                            height="40"
                          />
                        </div>
                        <div className="product-info">
                          <h6 className="mb-1">{product.name}</h6>
                          <div className="text-muted small">
                            <span className="me-2">⭐ {product.avgRating}</span>
                            <span>({product.totalReviews} reviews)</span>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </Col>
      ))}
    </Row>
  );
};

export default AccordionComponentHome;
